<template>
  <div class="settings">
    <h1>{{ $t("langcfg.txtStorage") }}</h1>
    <div class="print-content">
      <el-form label-position="left" label-width="300px">
        <el-form-item :label="`${$t('langcfg.txtDisk')}:`">
          <span :style="diskColor">{{ usage }}</span>
        </el-form-item>
        <br />
        <el-form-item :label="`${$t('langcfg.txtBackup')}:`">
          <div class="clear-database" @click="backUpDataBase">
            {{ $t("langcfg.txtBackupDataBase") }}
          </div>
        </el-form-item>
        <br />
        <el-form-item :label="`${$t('langcfg.txtClearDatabase')}:`">
          <div class="clear-database" @click="clearDatabase">
            {{ $t("langcfg.txtClearAllData") }}
          </div>
        </el-form-item>
        <br />
        <el-form-item
          v-if="usbDriver.status && usbUsage.capacity > 0"
          :label="`${$t('langcfg.txtUsbdriver')}:`"
        >
          <div style="display: flex; justify-content: center; align-items: center">
            <div style="width: 50%; font-size: 30px">
              {{ usbUsage.usage }}
            </div>
            <div style="width: 50%" class="clear-database" @click="ejectUSBDriver">
              {{ $t("langcfg.txtEjectUsbDriver") }}
            </div>
          </div>
        </el-form-item>
      </el-form>
      <br />
      <br />
      <br />
      <h1>{{ $t("langcfg.txtSharedFolder") }}</h1>
      <el-form label-position="left" label-width="300px">
        <br />
        <el-form-item :label="`${$t('langcfg.txtIP')}:`">
          <el-input
            @mousedown="handleClick('ip')"
            @focus="handleClick('ip')"
            v-model="sharedFolderInfo.ip"
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('langcfg.txtFolder')}:`">
          <el-input
            @mousedown="handleClick('folder')"
            @focus="handleClick('folder')"
            v-model="sharedFolderInfo.folder"
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('langcfg.txtUserName')}:`">
          <el-input
            @mousedown="handleClick('username')"
            @focus="handleClick('username')"
            v-model="sharedFolderInfo.username"
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('langcfg.txtPassword')}:`">
          <el-input
            @mousedown="handleClick('password')"
            @focus="handleClick('password')"
            v-model="sharedFolderInfo.password"
          ></el-input>
        </el-form-item>
      </el-form>
      <br />
      <el-row slot="footer" class="dialog-footer">
        <el-button type="info" class="btn-oprator" @click="configShareFolder">{{
          configBtnTest
        }}</el-button>
      </el-row>
    </div>
    <div v-if="isWaittingVisible" class="global-waitting">
      <span
        class="el-icon-close"
        style="position: absolute; left: 95%; top: 5%; font-size: 50px"
        @click="stopBackup"
      ></span>
      <div class="waitting-content">
        <span class="el-icon-loading waitting-icon"></span>
        <span class="waitting-text" id="waitting-text"
          >{{ $t("langcfg.txtProccessingData") + "..." }}
        </span>
        <span id="porcess-tip"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { getSystemTime, isLocalServer, objectCopy } from "../../../shared/utils";
import { Message } from "../../../mixins";
import fileSys from "../../../fileoprators/fileSystem";
import { reloadPatientDB } from "../../../services/patient";
import { reloadRecords } from "../../../services/record";
import EVENTS from "../../../bus";
import { mapState } from "vuex";
import ShareDisk from "./ShareDisk.vue";
import home from "../../../store/modules/home";
import { saveSettings } from "../../../settings";
import Backup from "../../../fileoprators/backup";
let backup;
export default {
  name: "Report",
  data() {
    return {
      backupPath: "",
      isWaittingVisible: false,
      sharedFolderInfo: {
        username: "",
        ip: "",
        folder: "",
        password: "",
        enabled: false,
        folderInLinux: "/home/mw520/shared_folder"
      },
      ismounting: false
    };
  },
  props: {
    percent: Number,
    diskUsage: "",
    usbDriver: {
      type: Object,
      default: () => {
        return { status: false };
      }
    }
  },
  components: {
    ShareDisk
  },
  computed: {
    usbUsage() {
      if (!this.usbDriver.status) {
        return "";
      } else {
        const { used, capacity } = this.usbDriver;

        const usedres = fileSys.capacityConverter(used);
        const capacityres = fileSys.capacityConverter(capacity);
        return {
          usage: `${usedres.value}${usedres.unit} / ${capacityres.value}${capacityres.unit}`,
          used: used,
          capacity: capacity
        };
      }
    },
    configBtnTest() {
      return this.ismounting ? this.$t("langcfg.txtLoading") : this.$t("langcfg.txtConfirm");
    },
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    }),
    diskColor: function () {
      return this.percent >= 95
        ? "line-height:50px;font-size:30px;color:red"
        : "line-height:50px;font-size:30px;color:#409eff";
    },
    usage: function () {
      if (this.percent < 0) {
        return "--";
      }
      let arr = this.diskUsage.split("/");
      if (parseInt(arr[1]) > 500) {
        return `${parseInt(arr[0]) + 276}G / ${parseInt(arr[1]) + 276}G`;
      }
      return this.diskUsage;
    },
    percentShow: function () {
      return this.percent < 0 ? "--" : this.percent;
    }
  },
  mixins: [Message],
  methods: {
    checkUsbdriver() {
      fileSys.getUDiskInfo((result) => {
        this.$emit("check-usbdriver", result);
      });
    },
    ejectUSBDriver() {
      if (fileSys.isUDiskExits().status) {
        fileSys.umountUsbDriver(window.usbDriver, () => {
          this.usbDriver.status = false;
          window.usbDriver = null;
          this.message(this.$t("langcfg.txtDiskIsUmounted"), "success");
        });
      }
    },
    stopBackup() {
      document.getElementById("waitting-text").innerHTML = this.$t("langcfg.txtStop") + "...";
      if (backup) {
        backup.stopBackup(() => {
          this.isWaittingVisible = false;
        });
      }
    },
    configShareFolder() {
      if (this.ismounting) return;
      if (
        this.sharedFolderInfo.ip === "" ||
        this.sharedFolderInfo.username === "" ||
        this.sharedFolderInfo.folder === ""
      ) {
        this.message(this.$t("langcfg.txtEmptyIPorFolderNotAllowed"), "error", 2000);
      } else {
        this.ismounting = true;
        window.settings.sharedFolder = objectCopy(this.sharedFolderInfo);
        saveSettings(window.settings);
        const { ip, folder, username, password } = this.sharedFolderInfo;
        fileSys.mountSharedFS([`${ip}/${folder}`, `${username}`, `${password}`], (error) => {
          this.ismounting = false;
          if (error) {
            if (error.message && error.message.indexOf("Permission denied") > 0) {
              this.message(this.$t("langcfg.txtPasswdOrUsernameWrong"), "error", 2000);
              return;
            }
            if (error.message && error.message.indexOf("No such file or directory") > 0) {
              this.message(this.$t("langcfg.txtFolderWrong"), "error", 2000);
              return;
            }
            if (error.message && error.message.indexOf("could not resolve address") > 0) {
              this.message(this.$t("langcfg.txtIpWrong"), "error", 2000);
              return;
            }
            this.message(this.$t("langcfg.txtSharedFolderWrong"), "error", 2000);
          } else {
            this.message(this.$t("langcfg.txtSharedFolderOK"), "success", 2000);
          }
        });
      }
    },
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.sharedFolderInfo[key], (value) => {
        self.sharedFolderInfo[key] = value;
      });
    },
    clearDatabase() {
      if (!isLocalServer()) {
        this.notify(this.$t("langcfg.txtCannotDeleteRemoteDatabase"), "", "error");
        return;
      }
      this.confirm(
        this.$t("langcfg.txtConfirmToClearData"),
        this.$t("langcfg.txtOK"),
        this.$t("langcfg.txtCancel"),
        ""
      )
        .then(() => {
          fileSys.clearAllFiles(window.localServerSettings.mediapath, [""], () => {
            fileSys.clearAllFiles(window.localServerSettings.casespath, [""], (err) => {
              console.log(err);
              this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtCleaningDatabase"));
              fileSys.clearAllFiles(window.localServerSettings.dbpath, [".db"], (err) => {
                console.log(err);
                reloadPatientDB((data) => {
                  reloadRecords((data) => {
                    this.$bus.$emit(EVENTS.hideGlobalWatting);
                    this.notify(this.$t("langcfg.txtCleanFinished"), "", "success");
                  });
                });
              });
            });
          });
        })
        .catch(() => {});
    },
    restorage() {},
    backUpDataBase() {
      this.confirm(
        this.$t("langcfg.txtConfirm2BackupDB"),
        this.$t("langcfg.txtOK"),
        this.$t("langcfg.txtCancel"),
        ""
      )
        .then(() => {
          const { status, location } = fileSys.isUDiskExits();
          if (status) {
            this.isWaittingVisible = true;
            this.$bus.$emit(EVENTS.canLogout, false);
            setTimeout(() => {
              backup = new Backup();
              const dst = fileSys.combinePath(
                location,
                `dea520backup/server_${getSystemTime("", "_", "")}`
              );
              const paths = backup.countFiles(
                window.localServerSettings.dbpath,
                window.localServerSettings.dbpath
              );
              const allFilesCount = paths.length || -1;
              backup.on("finish", () => {
                fileSys.clearCache(() => {
                  this.checkUsbdriver();
                  this.$bus.$emit(EVENTS.canLogout, true);
                  this.isWaittingVisible = false;
                  this.message(this.$t("langcfg.txtCopySuccess"), "success");
                });
              });
              backup.on("process", (count) => {
                let exportPercent = parseInt((count / allFilesCount) * 100);
                exportPercent = exportPercent >= 99 ? 99 : exportPercent;
                if (document.getElementById("porcess-tip")) {
                  document.getElementById("porcess-tip").innerHTML = exportPercent + "%";
                }
              });
              backup.on("error", (err) => {
                fileSys.clearCache(() => {
                  this.checkUsbdriver();
                  this.$bus.$emit(EVENTS.canLogout, true);
                  this.isWaittingVisible = false;
                  if (err && (err.message || "").toLocaleLowerCase().indexOf("no space") >= 0) {
                    this.message(this.$t("langcfg.txtNoSpaceLeft"), "error");
                  }
                });
              });
              setTimeout(() => {
                backup.copyFileByPipe(paths, dst);
              }, 1000);
            }, 1000);
          } else {
            this.$bus.$emit(EVENTS.canLogout, true);
            this.message(this.$t("langcfg.txtDiskIsMountedFailed"), "error");
          }
        })
        .catch((e) => {
          this.$bus.$emit(EVENTS.canLogout, true);
        });
    }
  },
  beforeDestroy() {
    this.$bus.$off(EVENTS.setStorage);
  },
  mounted() {
    this.sharedFolderInfo = objectCopy(window.settings.sharedFolder);
    this.checkUsbdriver();
  }
};
</script>
<style lang="less" scoped>
.settings {
  // margin-top: 60px;
  // margin-left: 60px;
  font-size: 23px;
  color: white;
  display: flex;
  align-items: left;
  flex-direction: column;
}
.info {
  margin-top: 20px;
}
.print-content {
  width: 800px;
  padding-left: 40px;
  margin-top: 20px;
}

.el-form /deep/ .el-form-item__label {
  font-size: 20px;
  padding: 0px;
  line-height: 40px;
}
.el-form /deep/ .el-form-item {
  margin-top: 20px;
}
.print-paper {
  width: 100%;
  border: #dcdfe6;
  border-radius: 4px;
  border-right: none;
  font-size: 30px;
  background: white;
  outline: none;
  height: 40px;
  color: #606266;
  padding-left: 15px;
}
.el-form /deep/ .el-form-item__label {
  font-size: 28px;
  padding: 0px;
  line-height: 50px;
}
.el-collapse {
  border: none;
  padding: 10px;
  padding-top: 30px;
  padding-left: 30px;
}
.el-collapse-item {
  margin-bottom: 25px;
}
.el-collapse /deep/ .el-collapse-item__content,
.el-collapse /deep/ .el-collapse-item__wrap {
  padding: 0px;
  border: none;
  background: transparent;
}
.el-collapse /deep/ .el-collapse-item__header {
  font-size: 30px;
  background: #2d3039;
  border: none;
  color: white;
}
.clear-database {
  display: flex;
  border: 1px solid gray;
  justify-content: center;
  align-items: center;
  height: 50px;
  font-size: 30px;
  line-height: 50px;
}
.global-waitting {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  .waitting-content {
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 10px;
    font-size: 25px;
    padding: 15px;
  }
  z-index: 2000;
}
.el-button {
  width: 200px;
  height: 50px;
  font-size: @header-fs;
  border: 1px solid gray;
  color: white;
}
.btn-oprator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-oprator:active {
  background: @btn-active-color;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/Storage.vue